export const SSO_LOGIN_LIVE_ORIGIN = 'https://go.fast.io';
export const SSO_LOGIN_DEV1_ORIGIN = 'https://go.fastdev1.com';
export const SSO_LOGIN_DEV2_ORIGIN = 'https://go.fastdev2.com';
export const SSO_LOGIN_DEV3_ORIGIN = 'https://go.fastdev3.com';

export const UPLOAD_FILE_RETRY_TIMEOUT = 3000;

export const GO_SUBDOMAIN = 'go';
